import React from "react";
import { Card, Row, Col, Typography } from "antd";

const { Title } = Typography;

export const GuestStatistics: React.FC = () => {
  return (
    <div>
      <Title level={3}>Gäste-Statistiken</Title>
      <Row gutter={16}>
        <Col span={24}>
          <Card>
            <p>Detaillierte Gäste-Statistiken werden hier implementiert...</p>
          </Card>
        </Col>
      </Row>
    </div>
  );
}; 